function preventCopyPaste($container) {

  if (Liferay.Browser.isMobile() && Liferay.Browser.isLinux()) {
    $container
      .on('input', '[type=email],[type=password]', function (e) {
        var $field = $(this),
            currentValue = $field.data('currentValue')

        if ( ($field.val().length - currentValue.length) > 1) {
          $field.val(null)
          $field.data('currentValue', '')
        } else {
          $field.data('currentValue', $field.val())
        }

      })
      .on('focus', '[type=email],[type=password]', function(e) {
        var $field = $(this)

        $field.data('currentValue', $field.val())
      })

  } else {

    $container.on('copy paste', '[type=email],[type=password]', function (e) {
      e.preventDefault()
      e.stopImmediatePropagation()
    })

  }
}

window.preventCopyPaste = preventCopyPaste

